import VueZoomer from 'vue-zoomer'

export default ({ app, router, Vue }) => {
	Vue.use(VueZoomer)
}
